// ========== 统一 Invoice 集成方案 ==========
if (typeof window.invoiceInitialized === 'undefined') {
  window.invoiceInitialized = true;

  window.updateInvoiceCount = function () {
    const savedData = JSON.parse(localStorage.getItem('invoiceItems') || '[]');
    const count = savedData.length;
    document.querySelectorAll('#invoiceCount, #invoiceCountMobile').forEach((countElement) => {
      countElement.textContent = count;
      countElement.style.display = 'inline-flex';
    });
  };

  window.addToInvoice = function (button) {
    const row = button.closest('tr');
    const item = {
      brand: row.querySelector('.brand-cell')?.textContent.trim() || button.getAttribute('data-brand'),
      partNumber: row.querySelector('.part-number-cell')?.textContent.trim() || button.getAttribute('data-part-number'),
      hsCode: '',
      package: row.querySelector('.package-cell')?.textContent.trim() || button.getAttribute('data-package'),
      year: row.querySelector('.year-input')?.value || '',
      qty: row.querySelector('.qty-input')?.value || '',
      price: row.querySelector('.price-input')?.value || '',
    };
    let items = JSON.parse(localStorage.getItem('invoiceItems') || '[]');
    items.push(item);
    localStorage.setItem('invoiceItems', JSON.stringify(items));
    window.updateInvoiceCount();
  };

  window.toggleInvoiceModal = function () {
    const modal = document.getElementById('invoice-modal');
    if (!modal) return;
    if (modal.style.display === 'none' || modal.style.display === '') {
      modal.style.display = 'flex';
      window.loadInvoiceData();
    } else {
      window.saveCurrentTableData();
      modal.style.display = 'none';
    }
  };

  document.addEventListener('mousedown', function (event) {
    const modal = document.getElementById('invoice-modal');
    if (modal && modal.style.display === 'flex') {
      if (event.target === modal || (!modal.contains(event.target) && !event.target.closest('[data-invoice-modal-trigger]'))) {
        window.toggleInvoiceModal();
      }
    }
  });

  window.saveCurrentTableData = function () {
    const tbody = document.getElementById('invoiceTableBody');
    if (!tbody) return;
    const allRows = tbody.querySelectorAll('tr:not(#addRowTrigger)');
    const invoiceItems = [];
    allRows.forEach((row) => {
      const inputs = row.querySelectorAll('.table-input');
      if (inputs.length >= 6) {
        const item = {
          brand: inputs[0].value || '',
          partNumber: inputs[1].value || '',
          hsCode: '',
          package: inputs[2].value || '',
          year: inputs[3].value || '',
          qty: inputs[4].value || '',
          price: inputs[5].value || '',
        };
        invoiceItems.push(item);
      }
    });
    localStorage.setItem('invoiceItems', JSON.stringify(invoiceItems));
    const shippingInput = document.getElementById('shippingInput');
    if (shippingInput) {
      localStorage.setItem('invoiceShipping', shippingInput.value || '0.00');
    }
    if (typeof window.updateInvoiceCount === 'function') {
      window.updateInvoiceCount();
    }
  };

  window.loadInvoiceData = function () {
    const items = JSON.parse(localStorage.getItem('invoiceItems') || '[]');
    const tbody = document.getElementById('invoiceTableBody');
    const trigger = document.getElementById('addRowTrigger');
    if (!tbody) return;
    const oldRows = tbody.querySelectorAll('tr:not(#addRowTrigger)');
    oldRows.forEach((r) => r.remove());
    items.forEach((item, index) => {
      const newRow = window.createInvoiceRow(item, index + 1);
      tbody.insertBefore(newRow, trigger);
    });
    if (items.length === 0) {
      window.addBlankRow();
    }
    const savedShipping = localStorage.getItem('invoiceShipping') || '0.00';
    if (document.getElementById('shippingInput')) {
      document.getElementById('shippingInput').value = savedShipping;
    }
    window.calculateTotals();
  };

  window.createInvoiceRow = function (item, index) {
    const row = document.createElement('tr');
    row.style.borderBottom = '1px solid #e2e8f0';
    row.innerHTML = `
      <td style="padding: 12px 8px; text-align: center; border-right: 1px solid #e2e8f0; font-size: 12px;">${index}</td>
      ${['brand', 'partNumber', 'package', 'year']
        .map(
          (k) => `
          <td style="padding: 12px 8px; border-right: 1px solid #e2e8f0;">
            <input type="text" class="table-input" value="${item[k] || ''}"
              onblur="window.saveCurrentTableData()"
              style="width:100%; border:none; background:transparent; text-align:center; font-size:12px; outline:none;">
          </td>`
        )
        .join('')}
      <td style="padding: 12px 8px; border-right: 1px solid #e2e8f0;">
        <input type="text" class="table-input qty-input" value="${item.qty || ''}"
          oninput="window.handleInputChange(this)"
          onblur="window.saveCurrentTableData()"
          style="width:100%; border:none; background:transparent; text-align:center; font-size:12px; outline:none;">
      </td>
      <td style="padding: 12px 8px; border-right: 1px solid #e2e8f0;">
        <input type="text" class="table-input price-input" value="${item.price || ''}"
          oninput="window.handleInputChange(this)"
          onblur="window.saveCurrentTableData()"
          style="width:100%; border:none; background:transparent; text-align:center; font-size:12px; outline:none;">
      </td>
      <td style="padding: 12px 8px; text-align: center; font-weight: 600; font-size: 12px;" class="amount-cell">0.00</td>
      <td style="padding: 12px 6px; text-align: center; cursor: grab; user-select: none; font-size: 14px; color: #94a3b8; width: 40px;" class="drag-handle" draggable="true">⋮⋮</td>
    `;
    window.calculateRowAmount(row);
    return row;
  };

  window.handleInputChange = function (input) {
    window.calculateRowAmount(input.closest('tr'));
    window.calculateTotals();
  };

  window.calculateRowAmount = function (row) {
    const qty = parseFloat(row.querySelector('.qty-input')?.value) || 0;
    const price = parseFloat(row.querySelector('.price-input')?.value) || 0;
    const amountCell = row.querySelector('.amount-cell');
    if (amountCell) amountCell.textContent = (qty * price).toFixed(2);
  };

  window.calculateTotals = function () {
    let subtotal = 0;
    document.querySelectorAll('.amount-cell').forEach((c) => (subtotal += parseFloat(c.textContent) || 0));
    const shipping = parseFloat(document.getElementById('shippingInput')?.value) || 0;
    document.getElementById('subtotalAmount').textContent = subtotal.toFixed(2);
    document.getElementById('totalAmount').textContent = (subtotal + shipping).toFixed(2);
  };

  window.addBlankRow = function () {
    const tbody = document.getElementById('invoiceTableBody');
    const trigger = document.getElementById('addRowTrigger');
    if (!tbody || !trigger) return;
    const currentRows = tbody.querySelectorAll('tr:not(#addRowTrigger)');
    const nextNumber = currentRows.length + 1;
    const newRow = window.createInvoiceRow({}, nextNumber);
    tbody.insertBefore(newRow, trigger);
    window.saveCurrentTableData();
    window.updateInvoiceCount();
  };

  window.removeLastRow = function () {
    const rows = document.querySelectorAll('#invoiceTableBody tr:not(#addRowTrigger)');
    if (rows.length > 0) {
      rows[rows.length - 1].remove();
      window.reOrderRows();
      window.saveCurrentTableData();
      window.updateInvoiceCount();
      window.calculateTotals();
    }
  };

  window.reOrderRows = function () {
    const tbody = document.getElementById('invoiceTableBody');
    const rows = tbody.querySelectorAll('tr:not(#addRowTrigger)');
    rows.forEach((row, index) => {
      const noCell = row.querySelector('td:first-child');
      if (noCell) noCell.textContent = index + 1;
    });
  };

  window.handlePlaceholderFocus = function (i) {
    i.style.outline = 'none';
  };

  window.handlePlaceholderBlur = function (i) {
    window.saveCurrentTableData();
  };

  // ========== 行拖拽排序功能 ==========
  window.initInvoiceDragAndDrop = function () {
    var tbody = document.getElementById('invoiceTableBody');
    if (!tbody) return;

    var dragRow = null;

    // 注入拖拽样式
    if (!document.getElementById('invoice-drag-styles')) {
      var styleEl = document.createElement('style');
      styleEl.id = 'invoice-drag-styles';
      styleEl.innerHTML =
        '#invoiceTableBody tr.dragging { opacity: 0.35; }' +
        '#invoiceTableBody tr.drag-over-top { border-top: 3px solid #3b82f6 !important; }' +
        '#invoiceTableBody tr.drag-over-bottom { border-bottom: 3px solid #3b82f6 !important; }' +
        '#invoiceTableBody .drag-handle { cursor: grab; transition: color 0.15s; }' +
        '#invoiceTableBody .drag-handle:hover { color: #3b82f6; }' +
        '#invoiceTableBody .drag-handle:active { cursor: grabbing; }';
      document.head.appendChild(styleEl);
    }

    tbody.addEventListener('dragstart', function (e) {
      var handle = e.target.closest('.drag-handle');
      if (!handle) { e.preventDefault(); return; }
      var row = handle.closest('tr');
      if (!row || row.id === 'addRowTrigger') { e.preventDefault(); return; }
      dragRow = row;
      row.classList.add('dragging');
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', '');
      // 用整行克隆作为拖拽预览图
      var clone = row.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.top = '-9999px';
      clone.style.width = row.offsetWidth + 'px';
      clone.style.opacity = '0.85';
      clone.style.background = '#f0f7ff';
      clone.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
      document.body.appendChild(clone);
      e.dataTransfer.setDragImage(clone, 0, 0);
      setTimeout(function () { clone.remove(); }, 0);
    });

    tbody.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      var targetRow = e.target.closest('tr');
      // 清除其他行的指示器
      tbody.querySelectorAll('.drag-over-top, .drag-over-bottom').forEach(function (r) {
        if (r !== targetRow) { r.classList.remove('drag-over-top', 'drag-over-bottom'); }
      });
      if (!targetRow || targetRow === dragRow) return;
      if (targetRow.id === 'addRowTrigger') {
        targetRow.classList.add('drag-over-top');
        return;
      }
      var rect = targetRow.getBoundingClientRect();
      var mid = rect.top + rect.height / 2;
      targetRow.classList.remove('drag-over-top', 'drag-over-bottom');
      if (e.clientY < mid) {
        targetRow.classList.add('drag-over-top');
      } else {
        targetRow.classList.add('drag-over-bottom');
      }
    });

    tbody.addEventListener('dragleave', function (e) {
      var row = e.target.closest('tr');
      if (row && !row.contains(e.relatedTarget)) {
        row.classList.remove('drag-over-top', 'drag-over-bottom');
      }
    });

    tbody.addEventListener('drop', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var targetRow = e.target.closest('tr');
      tbody.querySelectorAll('.dragging, .drag-over-top, .drag-over-bottom').forEach(function (r) {
        r.classList.remove('dragging', 'drag-over-top', 'drag-over-bottom');
      });
      if (!dragRow || !targetRow || targetRow === dragRow) { dragRow = null; return; }
      if (targetRow.id === 'addRowTrigger') {
        tbody.insertBefore(dragRow, targetRow);
      } else {
        var rect = targetRow.getBoundingClientRect();
        var mid = rect.top + rect.height / 2;
        if (e.clientY < mid) {
          tbody.insertBefore(dragRow, targetRow);
        } else {
          tbody.insertBefore(dragRow, targetRow.nextSibling);
        }
      }
      window.reOrderRows();
      window.saveCurrentTableData();
      window.calculateTotals();
      dragRow = null;
    });

    tbody.addEventListener('dragend', function () {
      tbody.querySelectorAll('.dragging, .drag-over-top, .drag-over-bottom').forEach(function (r) {
        r.classList.remove('dragging', 'drag-over-top', 'drag-over-bottom');
      });
      dragRow = null;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.updateInvoiceCount();
    window.initInvoiceDragAndDrop();
    const shipInput = document.getElementById('shippingInput');
    if (shipInput) shipInput.addEventListener('input', window.calculateTotals);
  });

}
